import { Link } from "react-router-dom";
import { CATEGORIES, SITE_NAME } from "../../mocks/site";

export default function Footer() {
  return (
    <footer className="border-t border-background-200/70 bg-secondary-100 text-foreground-800">
      <div className="mx-auto max-w-[1200px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-6">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50">
                <i className="ri-megaphone-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                吃瓜<span className="text-primary-600">17</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              今日新瓜速递，娱乐热点一站看。聚焦影视、综艺、音乐与热门话题，陪你不错过每一次新鲜围观。
            </p>
            <p className="mt-4 text-sm text-foreground-600">
              联系邮箱：<a href="mailto:hello@chigua17.example.com" className="text-primary-700 hover:underline">hello@chigua17.example.com</a>
            </p>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-sm font-semibold tracking-wide text-foreground-950">栏目导航</h3>
            <ul className="mt-4 space-y-3">
              {CATEGORIES.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/news?cat=${c.slug}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-sm font-semibold tracking-wide text-foreground-950">站点导航</h3>
            <ul className="mt-4 space-y-3">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-700">今日首页</Link></li>
              <li><Link to="/news" className="text-sm text-foreground-600 hover:text-primary-700">资讯速递</Link></li>
              <li><Link to="/hot" className="text-sm text-foreground-600 hover:text-primary-700">热门话题</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-700">关于我们</Link></li>
              <li><Link to="/faq" className="text-sm text-foreground-600 hover:text-primary-700">吃瓜指南</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-sm font-semibold tracking-wide text-foreground-950">关于内容</h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              吃瓜17致力于以客观、清晰的方式整理公开娱乐资讯，方便用户快速了解当前热门话题。本站不传播未经验证的不实信息，亦不对任何艺人或节目作主观评判。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {["理性吃瓜", "以正视听", "尊重作品"].map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-secondary-200/70 px-3 py-1 text-xs text-foreground-700"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {SITE_NAME} · 娱乐资讯聚合平台 · 内容仅作资讯分享
          </p>
          <p className="text-xs text-foreground-500">理性围观 · 尊重真实 · 快乐吃瓜</p>
        </div>
      </div>
    </footer>
  );
}